import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TalkAiAgentComponent } from './talk-ai-agent.component';

const routes: Routes = [
  {
    path: 'talkai', component: TalkAiAgentComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TalkAiAgentRoutingModule { }
